// shared/global app constants
export const prefix = 'mosaic';
// UNITS OF MEASUREMENT
// Sound
export const UNIT_DECIBEL = 'dB';
// Time
export const UNIT_SECOND = 'sec';
// Distances and Lengths
export const UNIT_METER = 'm';
export const UNIT_KILOMETER = 'km';
export const UNIT_FOOT = 'ft';
export const UNIT_FLIGHT_LEVEL = 'FL';
export const UNIT_MILE = 'mi';
export const UNIT_NAUTICAL_MILE = 'NM';
export const UNIT_INCH = 'in';
export const UNIT_MILLIMETER = 'mm';
export const UNIT_CENTIMETER = 'cm';
// Speed
export const UNIT_METERS_PER_SECOND = 'm/s';
export const UNIT_KNOT = 'kt';
export const UNIT_MILES_PER_HOUR = 'mph';
export const UNIT_KILOMETERS_PER_HOUR = 'km/h';
export const UNIT_FEET_PER_MIN = 'ft/min';
// Temperature
export const UNIT_CELCIUS = 'C';
export const UNIT_FAHREINHEIT = 'F';
export const UNIT_KELVIN = 'K';
// Pressure
export const UNIT_HECTOPASCAL = 'hPa';
export const UNIT_INCHES_OF_MERCURY = 'inHg';
export const UNIT_MILLIBAR = 'mb';
// Humidity
export const UNIT_PERCENTAGE = '%';
// Location and Angles (needs to be converted into required symbols upon use)
export const UNIT_DEGREE = 'degrees';
export const UNIT_DMS = 'dms';
// Mass
// SI units
export const UNIT_PICO_GRAM = 'pg';
export const UNIT_NANO_GRAM = 'ng';
export const UNIT_MICRO_GRAM = 'mcg';
export const UNIT_MILLI_GRAM = 'mg';
export const UNIT_GRAM = 'g';
export const UNIT_KILO_GRAM = 'kg';
export const UNIT_TONNE = 't';
export const UNIT_GIGA_GRAM = 'Gg';
export const UNIT_TERA_GRAM = 'Tg';
export const UNIT_PETA_GRAM = 'Pg';
// Imperial units
export const UNIT_PICO_OUNCE = 'poz';
export const UNIT_NANO_OUNCE = 'noz';
export const UNIT_MICRO_OUNCE = 'mcoz';
export const UNIT_MILLI_OUNCE = 'moz';
export const UNIT_OUNCE = 'oz';
export const UNIT_POUND = 'lb';
export const UNIT_US_TONNE = 'ton';
export const UNIT_KILO_US_TONNE = 'kton';
export const UNIT_MEGA_US_TONNE = 'Mton';
export const UNIT_GIGA_US_TONNE = 'Gton';
export const UNIT_TERA_US_TONNE = 'Tton';
export const UNIT_PETA_US_TONNE = 'Pton';
export const KILOGRAM_TO_POUNDS_CONVERSION_FACTOR = 2.20462;
export const POUNDS_TO_OUNCE_CONVERSION_FACTOR = 16;
// Graph
export const GRAPH_DEFAULT_LINE_COLOR = '#8C54FF';
// Ruler
export const RULER_SNAP_OFFSET = 40;
//# sourceMappingURL=constants.js.map